/**
 * @Author: Nemo
 * @Description: 卡信息组件验证规则
 * @Date: 2023-05-29
 * @FilePath: /rhcn-checkout-web/src/componentsV2/busi/card-information-form/rules.js
 */
import { i18n } from '@/language/index';

// Luhn算法验证卡号
export const luhn = (cardNumber) => {
  if (!cardNumber) return false;

  let total = 0;
  const cardNumberLength = cardNumber.length;
  if (cardNumberLength < 13 || cardNumberLength > 19) {
    return false;
  }
  const maxLength = cardNumberLength + 1;
  for (let i = 1; i < maxLength; i++) {
    let num = parseInt(cardNumber.substring(cardNumberLength - i, cardNumberLength - i + 1));
    if (i % 2 === 0) {
      num *= 2;
      if (num < 10) {
        total += num;
      } else {
        var t1 = num + '';
        total += parseInt(t1.substring(0, 1)) + parseInt(t1.substring(1, 2));
      }
    } else {
      total += num;
    }
  }
  return total % 10 === 0;
};

// 卡号校验
export const cardNumberRules = (value) => {
  // 为空时直接返回格式正确，支持外部必填验证
  if (!value) {
    return {
      result: true,
      message: '',
    };
  }

  // 有值时进行格式校验
  const num = value.replace(/\s*/g, '');
  const validate = luhn(num);

  return {
    result: validate,
    message: !validate ? i18n.t('message.validator.input', { field: i18n.t('message.checkout.cardNumber').toLowerCase() }) : '',
  };
};

// 有效期校验
export const effectiveDateRules = (value) => {
  // 为空时直接返回格式正确，支持外部必填验证
  if (!value) {
    return {
      result: true,
      message: '',
    };
  }

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  // 移除不必要的空格
  const trimmedValue = value.replace(/\s+/g, '');

  // 检查格式是否正确（必须是 MM/YY 或 MM/YYYY）
  if (!/^\d{2}\/(\d{2}|\d{4})$/.test(trimmedValue)) {
    return {
      result: false,
      message: i18n.t('message.validator.input', { field: i18n.t('message.checkout.expiredDate').toLowerCase() }),
    };
  }

  // 分割输入的值为月和年
  const [month, year] = trimmedValue.split('/').map(Number);

  // 校验月份是否有效
  if (month < 1 || month > 12) {
    return {
      result: false,
      message: i18n.t('message.validator.input', { field: i18n.t('message.checkout.expiredDate').toLowerCase() }),
    };
  }

  // 处理年份
  const fullYear = year < 100 ? currentYear - (currentYear % 100) + year : year;

  // 校验年份是否有效
  if (fullYear < currentYear || (fullYear === currentYear && month < currentMonth)) {
    return {
      result: false,
      message: i18n.t('message.validator.input', { field: i18n.t('message.checkout.expiredDate').toLowerCase() }),
    };
  }

  // 校验通过
  return {
    result: true,
    message: '',
  };
};

// cvv校验
export const cvvRules = (value) => {
  // 为空时直接返回格式正确，支持外部必填验证
  if (!value) {
    return {
      result: true,
      message: '',
    };
  }

  const trimmedValue = value.trim();
  const length = trimmedValue.length;

  // CVV 长度校验，至少为 3 位
  if (length >= 3) {
    return {
      result: true,
      message: '',
    };
  }

  // CVV 长度不足
  return {
    result: false,
    message: i18n.t('message.validator.input', { field: i18n.t('message.checkout.cvv').toLowerCase() }),
  };
};
